// newrelic-plugin.js
import { BrowserAgent } from '@newrelic/browser-agent';

/**
 * @var _store the VueX store
 */
let _store;

/** 
 * Retrieves application metadata from the VueX store
 * 
 * returns object with application metadata
 */
function getAppVersion() {
    const appVersion = _store.getters['appMetadataModule/version']

    return appVersion
}

/**
 * Retrieves customer metadata from the VueX store
 * 
 * @returns object with customer metadata
 */
function getCustomerMetadata() {
    const user = _store.getters['userModule/getUser']
    const customerContext = _store.getters['userModule/customerContext']
  
    // Map known user roles to a comma separated string of role codes
    let userRoles
    if (typeof user.roles === 'object') {
      userRoles = user.roles.map(role => {
        return role.code
      }).join(',')
    }

    return {
        customerName: customerContext.name,
        userEmail: user.email,
        userId: user.id,
        userName: user.full_name,
        userRoles: userRoles
    }    
}

function _install(Vue, options) {
    // Default configuration (can be customized)
    const defaultOptions = {
      init: {
        session_replay:{
            enabled:false,
            block_selector:'',
            mask_text_selector:'*',
            sampling_rate:10.0,
            error_sampling_rate:100.0,
            mask_all_inputs:true,
            collect_fonts:true,
            inline_images:false,
            inline_stylesheet:true,
            fix_stylesheets:true,
            mask_input_options:{}
        },
        distributed_tracing: {
          enabled: true, // Enable distributed tracing
        },
        privacy: {
          cookies_enabled: true, // Enable cookies for tracking
        },
        ajax: {
          deny_list: ["bam.nr-data.net"], // List of URLs to exclude from being tracked
        },
      },
      info: {
        beacon: 'bam.nr-data.net', // URL for the New Relic beacon
        errorBeacon: 'bam.nr-data.net', // URL for the New Relic error beacon
        licenseKey: process.env.VUE_APP_NEW_RELIC_LICENSE_KEY,
        applicationID: process.env.VUE_APP_NEW_RELIC_APP_ID,
        sa: 1,
      },
      loader_config: {
        accountID: process.env.VUE_APP_NEW_RELIC_ACCOUNT_ID, // Your New Relic Account ID
        trustKey: process.env.VUE_APP_NEW_RELIC_ACCOUNT_ID,   // Your New Relic Trust Key
        agentID: process.env.VUE_APP_NEW_RELIC_APP_ID,     // Your New Relic Agent ID
        licenseKey: process.env.VUE_APP_NEW_RELIC_LICENSE_KEY, // Your New Relic License Key
        applicationID: process.env.VUE_APP_NEW_RELIC_APP_ID, // Your New Relic Application ID
      },
    };

    // Merge custom options with default ones
    const finalOptions = { ...defaultOptions, ...options };

    // Initialize the New Relic Browser Agent with the provided options
    const newrelic = new BrowserAgent(finalOptions);

    // Set a custom attribute `env` based on the `ENV` environment variable
    const environment = process.env.VUE_APP_ENV || 'sandbox';
    newrelic.setCustomAttribute('env', environment); // Add `env` custom attribute for tracking

    // Set custom attributes based on the user and customer context
    const customerMetadata = getCustomerMetadata();
    newrelic.setCustomAttribute('customerName', customerMetadata.customerName);
    newrelic.setCustomAttribute('userEmail', customerMetadata.userEmail);
    newrelic.setCustomAttribute('userId', customerMetadata.userId);
    newrelic.setCustomAttribute('userName', customerMetadata.userName);
    newrelic.setCustomAttribute('userRoles', customerMetadata.userRoles);

    // Set applcation version
    newrelic.setApplicationVersion(getAppVersion());

    // Now you can use this.$newrelic inside your Vue components
    Vue.prototype.$newrelic = newrelic;
  }

function install(Vue, options, store) {
    _store = store;
    // Check if New Relic is enabled
    if (process.env.VUE_APP_NEW_RELIC_BMA_ENABLED !== '1') {
        return;
    }

    _install(Vue, options);
}

// Export the NewRelic plugin as a Vue plugin
const NewRelic = {
    install: install
};

export default NewRelic;